import React from 'react';
import { Typography } from './Typography';
import { StarIcon } from 'lucide-react';
import { t } from '../src/locales';
export const TestimonialSection = () => {
  const testimonials = t('testimonials.items');
  return <section id="testimonials" className="w-full bg-white py-20 px-6 md:px-12" data-id="element-109">
      <div className="max-w-6xl mx-auto" data-id="element-110">
        <div className="text-center mb-16" data-id="element-111">
          <h2 className="text-[50px] leading-[56px] text-[#192636] font-[200] mb-4" data-id="element-112">
            {t('testimonials.title')}
          </h2>
          <div className="flex justify-center mb-4" data-id="element-113">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-[#004FFF] fill-[#004FFF]" data-id="element-114" />)}
          </div>
          <Typography variant="medium" className="text-[#192636] max-w-2xl mx-auto" data-id="element-115">
            {t('testimonials.description')}
          </Typography>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-116">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#EBE6DC] p-8 rounded-xl" data-id="element-117">
              <Typography variant="medium" className="text-[#192636] italic mb-6" data-id="element-118">
                "{testimonial.quote}"
              </Typography>
              <div data-id="element-119">
                <Typography variant="medium" as="h4" className="text-[#192636] font-[200]" data-id="element-120">
                  {testimonial.author}
                </Typography>
                <Typography variant="small" className="text-[#192636] opacity-70" data-id="element-121">
                  {testimonial.role}
                </Typography>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};